import type { ColorPalette } from '@/features/colors/color.types';
import {
  NEUTRAL_COOL,
  NEUTRAL_GRAY,
  NEUTRAL_WARM,
} from '@/features/colors/neutrals';

// Slots in design's column order: pink, orange, yellow, tan, green, blue,
// purple, gray — note tan is color6, not color3. Shades by role: 500 primary
// accent, 300 muted, 100 light category, 50 shaded cell.
//
// Like the other sheet palettes, Sunset's sheet omits the warm/cool row, so the
// tie follows joyful's convention for the same eight columns.
export const sunsetPalette: ColorPalette = {
  id: 'sunset',
  name: 'Sunset',
  description: 'Navy to gold sweep',
  requiresPaidPlan: true,
  colors: {
    cool: { ...NEUTRAL_COOL },
    gray: { ...NEUTRAL_GRAY },
    warm: { ...NEUTRAL_WARM },
    color0: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#FFEDF4',
        '100': '#F9E4EF',
        '300': '#E79DC0',
        '500': '#D44C8D',
      },
    },
    color1: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#FFEEE7',
        '100': '#FDE8DE',
        '300': '#FCAE93',
        '500': '#F96C3A',
      },
    },
    color2: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#FEF1E3',
        '100': '#FEF1D9',
        '300': '#FFCE73',
        '500': '#FFA600',
      },
    },
    color3: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#EAF7F3',
        '100': '#DDF0EB',
        '300': '#84C1B8',
        '500': '#1F8F7D',
      },
    },
    color4: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#EFF4FD',
        '100': '#E0E4EF',
        '300': '#8E9BB8',
        '500': '#31497E',
      },
    },
    color5: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#F9F0FC',
        '100': '#EFE2F2',
        '300': '#C19EC9',
        '500': '#8E4E9C',
      },
    },
    color6: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#F9F2EB',
        '100': '#F1E9DE',
        '300': '#D0B79E',
        '500': '#A97C4E',
      },
    },
    color7: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#C1C1C4',
        '100': '#E4E3E6',
        '300': '#8A8A8A',
        '500': '#34333B',
      },
    },
  },
};
